<template>
  <main>
    <div class="container mt-4" v-if="rubricStore.state.rubricVersion">
      <div class="d-flex align-items-center">
        <h1>
          <i aria-hidden="true" class="fad fa-pencil-ruler"></i> Rubric: {{ rubricStore.state.rubric.name }}
        </h1>
        <div class="ms-auto d-flex gap-2">
          <button @click="downloadPDF" class="btn btn-sm btn-outline-primary">
            <i aria-hidden="true" class="far fa-download me-2"></i>Download PDF
          </button>
          <router-link :to="{name: 'ViewRubricVersions', params: {rid: $route.params.rid}}" class="btn btn-sm btn-link">Return to Rubric Versions</router-link>
        </div>
      </div>      
      <div class="d-flex align-items-center">
        <h2 class="text-muted me-4">
          <span v-if="mode === 'add'" class="small text-muted">
            Version #: Pending
          </span>
          <span v-if="mode === 'edit'" class="small text-muted">
            Version #: {{ rubricStore.state.rubricVersion.version }}
          </span>
        </h2>
        <div class="ms-auto">
          Status: <rubric-version-status-badge :status="rubricStore.state.rubricVersion.status" />
        </div>
      </div>
      <section>
        <ul class="nav nav-tabs nav-fill">
          <li class="nav-item">
            <button class="nav-link active" id="domains-tab" data-bs-toggle="tab" data-bs-target="#domains" type="button" role="tab" aria-controls="domains" aria-selected="true">
              Domains <span class="badge bg-primary ms-1">{{ (rubricStore.state.rubricVersion.metadata.domains || []).length }}</span>
            </button>
          </li>
          <!-- <li class="nav-item">
            <button class="nav-link" id="resources-tab" data-bs-toggle="tab" data-bs-target="#resources" type="button" role="tab" aria-controls="resources" aria-selected="false">
              Resources <span class="badge bg-primary ms-1">{{ (rubricStore.state.rubricVersion.metadata.resources || []).length }}</span>
            </button>
          </li> -->
        </ul>
        <div class="tab-content">
          <div class="tab-pane fade show active" id="domains" role="tabpanel" aria-labelledby="domains-tab">
            <div v-if="rubricStore.state.rubricVersion.metadata">
              <div v-if="!(rubricStore.state.rubricVersion.metadata.domains && rubricStore.state.rubricVersion.metadata.domains.length)">
                <div class="alert alert-warning text-center">No Domains have been defined for this Rubric Version.</div>
              </div>  
              <div v-else>
                <div v-for="(d, idx) in rubricStore.state.rubricVersion.metadata.domains" :key="d.key" class="row" >
                  <div class="col">
                    <domain :item="d" class="drag-el" :domain-index="idx" :domain-count="(rubricStore.state.rubricVersion.metadata.domains || []).length" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="tab-pane fade" id="resources" role="tabpanel" aria-labelledby="resources-tab">
            <div v-if="!(rubricStore.state.rubricVersion.metadata.resources && rubricStore.state.rubricVersion.metadata.resources.length)">
                <div class="alert alert-warning text-center">No Resources have been defined for this Rubric Version.</div>
            </div>
            <div v-else>
              <div class="row" v-for="(resource, index) in rubricStore.state.rubricVersion.metadata.resources" :key="`resource-${index}`">
                <div class="col">
                  <resource :item="resource" :resource-index="index" @input="resourcesChanged = true" />
                </div>
              </div>
            </div>
            <div class="d-flex p-3 rounded bg-secondary">
              <item-input-add class="flex-fill"
                @add-item="addResource($event.name)"
                item-type="Resource Name"/>
            </div>
            <div class="row mt-3">
              <div class="col text-end">
              </div>
            </div>
          </div> -->
        </div>
      </section>
    </div>
  </main>
</template>

<script lang="js">
import { defineComponent, watch, onBeforeMount, ref } from "@vue/composition-api";
import RubricVersionStatusBadge from "./components/RubricVersionStatusBadge.vue";
import Domain from "./components/Domain.vue";
import { injectStrict } from "@/lib/utils";
import { RubricStoreKey } from "@/store/StoreInjectionKeys";
import { RubricVersionStatus } from "@/generated/api.clients";
import EesDialog from "@/modules/ees/components/Dialog.vue"
import { jsPDF } from 'jspdf';


export default defineComponent({
  components: { Domain, RubricVersionStatusBadge, EesDialog, ref },
  setup(props, { root }) {
    const leaveGuardDialog = ref(null)
    const rubricStore = injectStrict(RubricStoreKey);

    onBeforeMount (async () => {
      await rubricStore.actions.loadRubric(Number(root.$route.params.rid));

      if (root.$route.params.vid) {
        await rubricStore.actions.loadRubricVersion(Number(root.$route.params.vid))
      }
    });

    watch(
      () => root.$route.params.vid,
      async newId => {
        if (newId) {
          await rubricStore.actions.loadRubricVersion(
            Number(newId)
          );
        }
      }
    ,
    {
      immediate: false
    });

    return {
      rubricStore,
    };
  },

  computed: {
    isDraft() {
      return (
        this.rubricStore.state.rubricVersion?.status ==
        RubricVersionStatus.Draft
      );
    },
    isActive() {
      return (
        this.rubricStore.state.rubricVersion?.status ==
        RubricVersionStatus.Active
      );
    }
  },
  methods: {
    downloadPDF() {
      const rubricName = this.rubricStore.state.rubric?.name || 'Rubric';
      const version = this.rubricStore.state.rubricVersion?.version || 'Unknown';
      const metadata = this.rubricStore.state.rubricVersion?.metadata;
      if (!metadata || !metadata.domains) return;

      const pdf = new jsPDF('l', 'mm', 'a4');
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const margin = 15;
      const contentWidth = pageWidth - 2 * margin;
      let y = margin;

      const performanceLevelText = (pl) => {
        switch (pl) {
          case 0: return 'Unsatisfactory';
          case 1: return 'Progressing';
          case 2: return 'Effective';
          case 3: return 'Highly Effective';
          default: return '';
        }
      };

      const checkPageBreak = (needed) => {
        if (y + needed > pageHeight - margin) {
          pdf.addPage();
          y = margin;
        }
      };

      // Title
      pdf.setFontSize(18);
      pdf.setFont(undefined, 'bold');
      pdf.text(rubricName, margin, y);
      y += 8;

      pdf.setFontSize(11);
      pdf.setFont(undefined, 'normal');
      pdf.text(`Version: ${version}`, margin, y);
      y += 12;

      // Domains
      for (let di = 0; di < metadata.domains.length; di++) {
        const domain = metadata.domains[di];
        
        checkPageBreak(20);
        
        // Domain header
        pdf.setFontSize(14);
        pdf.setFont(undefined, 'bold');
        pdf.setFillColor(240, 240, 240);
        pdf.rect(margin, y - 5, contentWidth, 9, 'F');
        pdf.text(`Domain ${di + 1}: ${domain.name}`, margin + 2, y);
        y += 12;

        // Components
        if (domain.components) {
          for (let ci = 0; ci < domain.components.length; ci++) {
            const comp = domain.components[ci];
            const compLabel = `${di + 1}${String.fromCharCode(ci + 97)}`;

            checkPageBreak(15);

            // Component header
            pdf.setFontSize(11);
            pdf.setFont(undefined, 'bold');
            pdf.text(`${compLabel}: ${comp.name}`, margin + 4, y);
            y += 7;

            // Performance levels as a table
            if (comp.performanceLevels && comp.performanceLevels.length) {
              const levels = comp.performanceLevels.sort((a, b) => a.level - b.level);
              const colCount = levels.length;
              const colWidth = contentWidth / colCount;

              // Header row
              checkPageBreak(30);
              pdf.setFontSize(9);
              pdf.setFont(undefined, 'bold');
              pdf.setFillColor(220, 220, 220);
              pdf.rect(margin, y - 4, contentWidth, 6, 'F');
              
              for (let li = 0; li < levels.length; li++) {
                const x = margin + (li * colWidth);
                pdf.text(performanceLevelText(levels[li].level), x + 2, y);
              }
              y += 5;

              // Content row - wrap text in each column
              pdf.setFont(undefined, 'normal');
              pdf.setFontSize(8);

              let maxHeight = 0;
              const wrappedTexts = [];

              for (let li = 0; li < levels.length; li++) {
                const desc = levels[li].description || '';
                const lines = pdf.splitTextToSize(desc, colWidth - 4);
                wrappedTexts.push(lines);
                const height = lines.length * 3.5;
                if (height > maxHeight) maxHeight = height;
              }

              checkPageBreak(maxHeight + 8);

              // Draw cell borders
              for (let li = 0; li < levels.length; li++) {
                const x = margin + (li * colWidth);
                pdf.setDrawColor(200, 200, 200);
                pdf.rect(x, y - 2, colWidth, maxHeight + 4);
                pdf.text(wrappedTexts[li], x + 2, y + 1.5);
              }

              y += maxHeight + 8;
            }
          }
        }
        y += 5;
      }

      pdf.setProperties({
        title: `${rubricName} v${version}`,
        subject: 'EES Rubric'
      });

      pdf.save(`${rubricName}_v${version}.pdf`);
    }
  },
  props: {
    mode: {
      type: String,
      required: true
    }
  }
});
</script>
